<script lang="ts">
    import { dictionary } from "@app/services/currentDictionary.service";

    import { glosbeTranslateIsDictionarySupported } from "./GlosbeTranslate-supportedLanguages";

    import GlosbeTranslatePresenter from "./GlosbeTranslatePresenter.svelte";
    import { googleTranslateIsDictionarySupported } from "./GoogleTranslate-supportedLanguages";

    import GoogleTranslatePresenter from "./GoogleTranslatePresenter.svelte";
    import { getGlosbeTransferState } from "@app/services/transferState-service";

    const phrase = getGlosbeTransferState().phrase;

    const glosbeTranslatorSupportsCurrentDictionary =
        glosbeTranslateIsDictionarySupported(
            $dictionary.l1.code,
            $dictionary.l2.code
        );
    const googleTranslateSupportsCurrentDictionary =
        googleTranslateIsDictionarySupported(
            $dictionary.l1.code,
            $dictionary.l2.code
        );

    const translatorsSupportCurrentDictionary =
        googleTranslateSupportsCurrentDictionary ||
        glosbeTranslatorSupportsCurrentDictionary;

    const parentContainer = document.getElementById("translation_automatic");
    if (parentContainer) {
        let initialized = false;
        let observer: IntersectionObserver | undefined;

        function initializeIfVisible(
            intersectionEntries: IntersectionObserverEntry[]
        ) {
            let isVisible = intersectionEntries.reduce(
                (visible, entry) => visible || entry.isIntersecting,
                false
            );
            if (
                translatorsSupportCurrentDictionary &&
                isVisible &&
                !initialized
            ) {
                initialized = true;
                if (observer !== undefined) {
                    observer.disconnect();
                }

                const glosbeTranslateContainer = document.getElementById(
                    "glosbeTranslate_container"
                );
                if (glosbeTranslateContainer) {
                    new GlosbeTranslatePresenter({
                        target: glosbeTranslateContainer,
                        props: {
                            phrase,
                            containerElement: glosbeTranslateContainer,
                        },
                    });
                }

                const googleTranslateContainer = document.getElementById(
                    "googleTranslate_container"
                );
                if (googleTranslateContainer) {
                    new GoogleTranslatePresenter({
                        target: googleTranslateContainer,
                        props: {
                            phrase,
                            containerElement: googleTranslateContainer,
                        },
                    });
                }
            }
        }

        observer = new IntersectionObserver(initializeIfVisible);
        observer.observe(parentContainer);
    }
</script>
